import api from './base';

class MeetingTypeFlowAllowsApi {
  public getByMeetingType = async (meetingTypeId: string): Promise<string[]> => {
    const { data } = await api.get('/meeting-type-flow-allows', {
      params: { meetingTypeId },
    });
    return data.data.map((item: any) => item.visitFlowTypeId);
  };
}

export default new MeetingTypeFlowAllowsApi();
